/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::04f340248c4142a991ad78e080057fbe>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "FullscreenExit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for return screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const FullscreenExitIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 12v3H10v-3a2 2 0 0 1 2-2h3v1.5h-3a.5.5 0 0 0-.5.5m-7 3v-3a.5.5 0 0 0-.5-.5H1V10h3a2 2 0 0 1 2 2v3zM12 4.5h3V6h-3a2 2 0 0 1-2-2V1h1.5v3a.5.5 0 0 0 .5.5m-8 0a.5.5 0 0 0 .5-.5V1H6v3a2 2 0 0 1-2 2H1V4.5z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
FullscreenExitIcon.displayName = 'FullscreenExitIcon';
var _default = exports.default = FullscreenExitIcon;